<div class="admin-login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Lenali - Espace Administrateur</mat-card-title>
    </mat-card-header>
    
    <mat-card-content>
      <p class="login-info">Connectez-vous pour accéder à l'interface d'administration</p>
      <p class="login-restriction">Seuls les administrateurs autorisés peuvent accéder à cette section</p>
      
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-error *ngIf="loginError" class="login-error">
          {{ loginError }}
        </mat-error>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" placeholder="admin@example.com">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            L'email est requis
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            Veuillez entrer un email valide
          </mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mot de passe</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
          <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
            Le mot de passe est requis
          </mat-error>
          <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
            Le mot de passe doit contenir au moins 6 caractères
          </mat-error>
        </mat-form-field>
        
        <div class="button-container">
          <button 
            type="submit" 
            mat-raised-button 
            color="primary" 
            [disabled]="loginForm.invalid || isLoading">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">Se connecter</span>
          </button>
        </div>
      </form>
    </mat-card-content>
    
    <mat-card-actions>
      <a mat-button routerLink="/">Retour au site principal</a>
    </mat-card-actions>
  </mat-card>
</div>
